// extracted by mini-css-extract-plugin
module.exports = {"blogItem":"styles_blogItem__BKj_d","blogItemTitle":"styles_blogItemTitle__d5o_n","blogItemImage":"styles_blogItemImage__oi0r5","blogItemDate":"styles_blogItemDate__VrMmW"};